// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"10f02ff4c1f1aff418e5","532":"c418b5551dda9e348503","691":"81a31b5e77216833da72"}[chunkId] + ".js";
};